import { render, staticRenderFns } from "./Strut1000-F.vue?vue&type=template&id=1c3eac5c"
import script from "./Strut1000-F.vue?vue&type=script&lang=js"
export * from "./Strut1000-F.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports